import axiosClient from './axiosClient'

const prefixPath = '/location-check-ticket'

const checkPointApi = {
  create: async (params) => {
    return axiosClient.post(`${prefixPath}/create`, params)
  },
  update: async (params) => {
    return axiosClient.put(
      `${prefixPath}/update/${params.locationCheckTicketId}`,
      params,
    )
  },
  find: async (params) => {
    return axiosClient.get(`${prefixPath}/find`, { params })
  },
  getDetail: async (params) => {
    return axiosClient.get(
      `${prefixPath}/detail/${params.locationCheckTicketId}`,
    )
  },
  delete: async (data) => {
    return axiosClient.delete(`${prefixPath}/delete`, { data })
  },
}

export default checkPointApi
